<div fxFlex=100 fxFlex.lt-md=100 class="showcase-main-section">
    <div class="web-view">
        <!-- <div id="movie-cart" fxLayoutAlign="end end">
            <app-shopping-cart ></app-shopping-cart>

        </div>-->

        <div *ngIf="!errorApi && movieDisplayed">
            <div [id]="'movies'+movieDisplayed?.id" (click)="imgDetail(movieDisplayed)" #testScroll>
                <div class="web-background" style="background-image: url('{{movieDisplayed?.eventImage}}');">
                </div>

            </div>
        </div>

        <div class="movieList" class="flex-item" fxLayout="row" *ngIf="!errorApi && movieDisplayed">
            <div style="z-index: auto !important;" class="img-container">

                <ng-container *ngFor="let movie of sortMovies(movieList, 'name', 'asc')">
                    <div class="img-div" [id]="'movies'+movie.id" (click)="imgDetail(movie)" #testScroll>
                        <img id="img" src="{{movie?.image}}">
                        <img class="waterMarked" [src]="officialLogo" alt="">
                    </div>
                </ng-container>
            </div>

            <div class="description-div" #descriptionScrollContainer>
                <h1 style="max-width: 30vw;">{{movieDisplayed?.name}}</h1>
                <hr width="20px">
                <div fxLayoutAlign="row" fxLayoutGap="30px">
                    <div *ngIf="movieDisplayed?.audienceRating">{{movieDisplayed?.audienceRating}}/10</div>
                    <div *ngIf="movieDisplayed?.duration">{{movieDisplayed?.duration}} mins</div>
                </div>
                <div class="paragraph-div">
                    <p [innerHTML]="movieDisplayed?.description"></p>
                    <div>
                        <p *ngIf="movieDisplayed?.cast">Starring {{movieDisplayed?.cast}}</p>
                    </div>
                    <div fxLayoutAlign="row" fxLayoutGap="30px">
                        <div>{{movieDisplayed?.language}}</div>
                        <div>{{movieDisplayed?.country}}</div>
                    </div>

                    <div class="button-div" fxLayout="row wrap" fxLayoutGap="10px">
                        <button *ngFor="let tags of movieDisplayed?.tags">{{tags}}</button>
                    </div>
                    <!-- <p>Official Selection of Cinejoy featuring Cinquest Artists{{movie.currentShowings[2]}}</p> -->
                    Official Selection of Cinejoy featuring Cinequest Artists March 24 - March 31, 2025 
                    <br />
                    <button class="movie_button" *ngIf="movieDisplayed?.showbuybutton && isBuyButtonActive | async"
                        (click)="openPaymentFlow(movieDisplayed?.id, movieDisplayed, 'Buy')">Buy</button>
                    <button class="movie_button" *ngIf="movieDisplayed?.showwatchbutton"
                        [routerLink]="['/cinejoy/showcase/movie/stream', movieDisplayed?.id, getmovieName(movieDisplayed.name)]">Watch</button>
                    <button #cd class="movie_button"
                        (click)="navigateToMovieInfo(movieDisplayed)">Movie Page</button>
                    <button *ngIf="!movieDisplayed.bookmarked && pass" 
                        style="border: none;"
                        (click)="bookmarkEvent(movieDisplayed.eventId, true)">
                        <img src="../../../../../assets/images/pass.png" alt="Bookmark Image" width="40px" height="37.5px" />
                    </button>

                    <button *ngIf="movieDisplayed.bookmarked && pass" 
                        style="border: none;"
                        (click)="alreadyBookmarkEvent(true)">
                        <img src="../../../../../assets/images/Bookmarked.png" alt="Bookmark Image" width="40px" height="37.5px" />
                    </button>

                <button data-bs-toggle="modal" data-bs-target="#shareModal" class="movie_button">
                    <i class="bi bi-share-fill" aria-hidden="true"></i>
                    <meta name="description" content="Free Web tutorials f">
                </button>

                </div>
            </div>
        </div>
        <ng-container *ngIf="errorApi">
            <div class="No-Movie-container" fxLayout="row wrap" fxLayoutAlign="center center">
                <p>No movies found. Please try different search results.</p>
            </div>
        </ng-container>
    </div>
    <div class="mobile-view" >
        <ng-container *ngIf="errorApi">
            <div class="No-Movie-container" fxLayout="row wrap" fxLayoutAlign="center center">
                <p>No movies found. Please try different search results.</p>
            </div>
        </ng-container>
    <!-- <app-showcase ></app-showcase> -->
    </div>
</div>

<div class="modal fade" id="shareModal" tabindex="-1" aria-labelledby="shareModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="shareModalLabel">Share</h5>
                <button type="button" data-bs-dismiss="modal" aria-label="Close">x</button>
            </div>
            <div class="modal-body text-center">
                <!-- Share Icons -->
                <div class="row text-center mb-3">
                    <div class="col-6 col-md-3 mb-2">
                        <button class="btn btn-light w-100 share-btn" (click)="shareButton('email')" aria-label="Share via Email">
                            <i class="bi bi-envelope fs-3"></i><br><span class="small">Email</span>
                        </button>
                    </div>
                    <div class="col-6 col-md-3 mb-2">
                        <button class="btn btn-light w-100 share-btn" (click)="shareButton('facebook')"
                            aria-label="Share on Facebook">
                            <i class="bi bi-facebook fs-3"></i><br><span class="small">Facebook</span>
                        </button>
                    </div>
                    <div class="col-6 col-md-3 mb-2">
                        <button class="btn btn-light w-100 share-btn" (click)="shareButton('twitter')"
                            aria-label="Share on Twitter">
                            <i class="bi bi-twitter-x fs-3"></i><br><span class="small">X</span>
                        </button>
                    </div>
                    <div class="col-6 col-md-3 mb-2">
                        <button class="btn btn-light w-100 share-btn" (click)="shareButton('instagram')"
                            aria-label="Share on Instagram">
                            <i class="bi bi-instagram fs-3"></i><br><span class="small">Instagram</span>
                        </button>
                    </div>
                </div>
                <!-- Copy Link -->
                <div class="row">
                    <div class="col-12">
                        <button class="btn btn-secondary w-100" (click)="shareButton('copy-link')"
                            aria-label="Copy Link">
                            Copy link
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>